export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
export const SET_PRIVATE_CHANNEL = 'SET_PRIVATE_CHANNEL';
export const SET_STARRED_CHANNEL = 'SET_STARRED_CHANNEL';
export const SET_USER_TOTAL_POSTS = 'SET_USER_TOTAL_POSTS';